import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=05c8dbca&scoped=true&"
import script from "./MainNavigation.vue?vue&type=script&lang=js&"
export * from "./MainNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=05c8dbca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c8dbca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VIcon,VList,VListGroup,VListItem,VListItemAction,VListItemIcon,VListItemTitle})
